<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col cols="6" class="py-0">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn v-if="isAdmin" :disabled="!lines.length" color="tertiary" @click="openPdf()" class="mr-3">Pdf</v-btn>
        <ConfirmDialog ref="confirmFinalize" title="Afronden" @confirm="finalize"></ConfirmDialog>
        <v-btn v-if="!isFinalized" :disabled="!canBeFinalized" color="tertiary" @click="$refs.confirmFinalize.showDialog()" class="mr-3">Afronden</v-btn>
        <ConfirmDialog ref="confirmDuplicate" title="Dupliceren" @confirm="duplicate"></ConfirmDialog>
        <v-btn v-if="isFinalized" color="secondary" @click="$refs.confirmDuplicate.showDialog()" class="mr-3">Dupliceren</v-btn>
        <ConfirmDialog ref="confirmActivate" title="Activeren" @confirm="activate"></ConfirmDialog>
        <v-btn v-if="isAdmin && isFinalized" color="secondary" @click="$refs.confirmActivate.showDialog()" class="mr-3">Heractiveren</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
          <v-expansion-panels v-model="panelState">
            <v-expansion-panel>
              <v-expansion-panel-header v-slot="{ open }">
                <v-row>
                  <v-col cols="4">Projectgegevens <v-fade-transition><v-icon v-if="showSuccessCheck" dense color="tertiary">mdi-check</v-icon></v-fade-transition></v-col>
                  <v-col
                    cols="8"
                    class="text--secondary"
                  >
                    <v-fade-transition>
                      <v-row
                        no-gutters
                        v-if="!open"
                      >
                        <v-col cols="4">Projectnummer: {{ item.project_number }}</v-col>
                        <v-col cols="4">Bonnummer: {{ item.reference_number }}</v-col>
                        <v-col cols="4">Afleverplaats: {{ item.delivery_address_city }}</v-col>
                      </v-row>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form
                  :disabled="isFinalized"
                  autocomplete="off"
                  ref="test"
                >
                  <v-row>
                    <v-col cols="4" sm="4">
                      <v-text-field
                        v-model="item.project_number"
                        label="Projectnummer"
                        :error-messages="errors.project_number"
                        autocomplete="off"
                      ></v-text-field>
                      <v-text-field
                        v-model="item.reference_number"
                        label="Bonnummer"
                        :error-messages="errors.reference_number"
                        autocomplete="off"
                      ></v-text-field>
                      <v-menu
                        v-model="deliveryDateDialog"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :disabled="!isDeliveryDateAvailable"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="formatDate(item.desired_delivery_date)"
                            label="Gewenste leverdatum"
                            :error-messages="errors.desired_delivery_date"
                            clearable
                            readonly
                            :disabled="!isDeliveryDateAvailable"
                            autocomplete="off"
                            v-bind="attrs"
                            v-on="on"
                            @click:clear="item.desired_delivery_date = null"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="item.desired_delivery_date"
                          locale="nl-nl"
                          :allowed-dates="allowedProjectDates"
                          @input="deliveryDateDialog = false"
                        ></v-date-picker>
                      </v-menu>
                      <v-switch
                        v-model="item.is_urgent"
                        @change="handleUrgent"
                        label="Spoed">
                      </v-switch>
                    </v-col>
                    <v-col cols="4" sm="4">
                      <v-text-field
                        v-model="item.contact_name"
                        label="Contactpersoon"
                        :error-messages="errors.contact_name"
                        autocomplete="off"
                      ></v-text-field>
                      <v-text-field
                        v-model="item.contact_phone_number"
                        label="Telefoonnummer"
                        :error-messages="errors.contact_phone_number"
                        autocomplete="off"
                      ></v-text-field>
                      <v-textarea
                        v-model="item.delivery_remarks"
                        label="Opmerkingen"
                        :error-messages="errors.delivery_remarks"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="4" sm="4">
                      <p>Afleveradres</p>
                      <v-text-field
                        v-model="item.delivery_address_street"
                        label="Straat"
                        :error-messages="errors.delivery_address_street"
                        autocomplete="off"
                      ></v-text-field>
                      <v-text-field
                        v-model="item.delivery_address_house_number"
                        label="Huisnummer"
                        :error-messages="errors.delivery_address_house_number"
                        autocomplete="off"
                      ></v-text-field>
                      <v-text-field
                        v-model="item.delivery_address_postcode"
                        label="Postcode"
                        :error-messages="errors.delivery_address_postcode"
                      ></v-text-field>
                      <v-text-field
                        v-model="item.delivery_address_city"
                        label="Plaats"
                        :error-messages="errors.delivery_address_city"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-right">
                      <v-btn v-if="!isFinalized" color="primary" @click="updateItem">Opslaan</v-btn>
                      <v-btn color="default" @click="resetItem" class="ml-2">Annuleren</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="5">
        <v-alert
          v-if="Object.keys(productSummary).length"
          dense
          color="secondary"
          text
          class="mb-0"
        >{{ formatKeyValue(productSummary) }}</v-alert>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6" class="text-right">
        <v-btn v-if="!isFinalized" color="tertiary" @click="showProductDialog" class="mr-3">Product toevoegen</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="lines"
            disable-filtering
            disable-pagination
            disable-sort
            hide-default-footer
            @click:row="toProjectLine"
          >

            <template v-slot:no-data>
              <span>Voeg producten toe</span>
            </template>

            <template v-slot:item.quantity="{ item }">
              {{ Number(item.quantity) }} {{ item.product.template == 'glazing_bead' ? 'm¹' : 'stuks' }}
            </template>

            <template v-slot:item.is_validated="{ item }">
              <v-icon
                small
                :color="item.is_validated ? 'green' : 'grey'"
              >mdi-circle-medium</v-icon>
            </template>

            <template v-slot:item.action="{ item }">
              <v-icon
                v-if="!isFinalized"
                small
                @click.stop="$refs.confirmDuplicateLine.showDialog(item.id)"
              >mdi-content-copy</v-icon>
              <v-icon
                v-if="!isFinalized"
                small
                class="ml-2"
                @click.stop="$refs.confirmDeleteLine.showDialog(item.id)"
              >mdi-trash-can-outline</v-icon>
            </template>

          </v-data-table>

          <ProductDialog ref="productDialog" @update="createLine" />
          <ConfirmDialog ref="confirmDuplicateLine" title="Dupliceren" @confirm="duplicateLine"></ConfirmDialog>
          <ConfirmDialog ref="confirmDeleteLine" title="Verwijderen" @confirm="deleteLine"></ConfirmDialog>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import ProductDialog from '@/components/ProductDialog'
import moment from 'moment'
import ConfirmDialog from '@/components/ConfirmDialog'
import { mapGetters } from 'vuex'

export default {
  components: {
    ProductDialog,
    ConfirmDialog,
  },
  data: () => ({

    panelState: null,
    showSuccessCheck: false,

    deliveryDateDialog: false,

    item: {},
    errors: {},

    loading: false,
    lines: [],

    headers: [
      { text: '', value: 'is_validated', align: 'left', sortable: false, width: '2%' },
      { text: 'Product', value: 'product.name', align: 'left', sortable: false, width: '22%' },
      { text: 'Afmetingen', value: 'dimensions', align: 'left', sortable: false, width: '22%' },
      { text: 'Categorie', value: 'product.category.name', align: 'left', sortable: false, width: '22%' },
      { text: 'Aantal', value: 'quantity', align: 'left', sortable: false, width: '22%' },
      { text: 'Acties', value: 'action', align: 'center', sortable: false, width: '10%' },
    ],




  }),
  watch: {
    projectId: function() {
      this.fetchItem()
      this.fetchLines()
    }
  },
  computed: {
    ...mapGetters('auth', ['isAdmin']),
    projectId() {
      return Number(this.$route.params.projectId)
    },
    isDeliveryDateAvailable() {
      return !this.item.is_urgent
    },

    productSummary() {
      let categories = {}
      Object.keys(this.lines).forEach((index) => {
        let line = this.lines[index]
        let categoryName = line.product.category.name
        if (!categories[categoryName]) {
          categories[categoryName] = 0
        }
        categories[categoryName] += Number(line.quantity)
      })
      return categories
    },

    isFinalized() {
      return this.item.status == 20
    },

    canBeFinalized() {
      
      let canBeFinalized = !!this.lines.length

      this.lines.forEach((line) => {
        if (!line.is_validated) {
          canBeFinalized = false
        }
      })

      return canBeFinalized
    },
  },
  created() {
    this.fetchItem()
    this.fetchLines()

    this.breadcrumbs = [{
      text: 'Projecten',
      disabled: false,
      to: {
        name: 'projects',
      },
    }, {
        text: 'Project',
        disabled: true,
    }]

  },
  methods: {
    showProductDialog() {
      this.$refs.productDialog.showDialog()
    },
    toProjectLine(item) {
      this.$router.push({
        name: 'project-line',
        params: {
          lineId: item.id,
        },
      })
    },
    formatKeyValue(obj, separator = ' | ') {
      let lst = []
      Object.keys(obj).forEach(key => {
        lst.push(key + ': ' + obj[key])
      })
      return lst.join(separator)
    },
    fetchLines() {
      this.loading = true
      ApiService.index(`/projects/${this.projectId}/lines`, null, {
        params: {
          expand: 'product,product.category,dimensions',
        }
      }).then((items)  => {
        this.lines = items
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    },
    createLine(product) {
      this.$store.dispatch('session/showLoader')
      ApiService.create(`/projects/${this.projectId}/lines`, {
        product_id: product.id,
      }).then((item) => {
        this.toProjectLine(item)
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    deleteLine(lineId) {
      ApiService.delete(`/project-lines/${lineId}`).finally(() => {
        this.fetchLines()
      })
    },
    duplicateLine(lineId) {
      ApiService.create(`/project-lines/${lineId}/duplicate`).finally(() => {
        this.fetchLines()
      })
    },
    hidePanel() {
      this.panelState = null
    },
    handleUrgent(val) {
      if (val) {
        this.item.desired_delivery_date = null
      }
    },
    allowedProjectDates(date) {
      return moment(date).isSameOrAfter(moment().add(2, 'weeks'))
    },
    formatDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : null
    },
    fetchItem() {
      this.$store.dispatch('session/showLoader')
      ApiService.view(`/projects/${this.projectId}`, {
        params: {
        },
      }).then(item => {
        this.item = item
      }).catch(() => {
        this.$router.push({ name: 'projects' })
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    updateItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
      ApiService.update(`/projects/${this.projectId}`, {
        ...this.item,
      }).then(() => {
        this.hidePanel()
        this.showSuccess()
      }).catch(errors => {
        this.errors = errors
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    resetItem() {
      this.hidePanel()
      this.fetchItem()
    },
    showSuccess() {
      this.showSuccessCheck = true
      setTimeout(() => {
        this.showSuccessCheck = false
      }, 750)
    },
    finalize() {
      this.$store.dispatch('session/showLoader')
      ApiService.post(`/projects/${this.projectId}/finalize`).then(() => {
        this.$router.push({
          name: 'projects',
        })
      }).catch(() => {
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    activate() {
      this.$store.dispatch('session/showLoader')
      ApiService.post(`/projects/${this.projectId}/activate`).then(() => {
        this.fetchItem()
      }).catch(() => {
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    duplicate() {
      this.$store.dispatch('session/showLoader')
      ApiService.post(`/projects/${this.projectId}/duplicate`).then(project => {
        this.$router.push({
          name: 'project',
          params: {
            projectId: project.id,
          },
        })
      }).catch(() => {
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    openPdf() {
      this.$store.dispatch('session/showLoader')
      ApiService.get(`/projects/${this.projectId}/pdf`, {
        responseType: 'blob',
      }).then((blob) => {
        let url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')

      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
  }

}
</script>

<style scoped>

::v-deep .v-data-table table tbody tr:not(.v-data-table__empty-wrapper):hover {
  cursor: pointer;
}

</style>